const is = require('../plugins/helper/is')
const { initSW } = require('../../plugins/push')
const { listen } = require('../plugins/event/listen')
const Swal = require('../plugins/sweet/Alert').default

const defaultSwal = {
  toast: true,
  timer: 2000,
  position: 'top-start',
  showConfirmButton: false,
  timerProgressBar: false,
}

const event = listen('#button_allow_browser_notifications', 'click', (e) => {
  e.preventDefault()

  const trigger = e.delegateTarget || e.currentTarget
  trigger.disabled = true
  const action = is.getAttributeValue(trigger, 'action')
  const cedula = is.getNode('#subscription-confirmation-form #subscription-registration').value

  const currentForm = is.objectToFormData({ 'primary': cedula })

  // Click enable
  const promiseNotify = initSW(currentForm)
  promiseNotify.then(() => {
    const formData = new FormData(is.getNode('#subscription-confirmation-form'))

    const promise = Swal.axiosPost(formData, action)
    promise.then(response => {
      Swal.handleResult(true, { data: response.data ?? null, trigger }, 'success-subscription-registration')
    }).catch(error => {
      Swal.handleResult(false, { error, trigger }, 'error-subscription-registration')
    })

    return false
  })

  return false
})

// Listeners
Swal.handleOn('success-subscription-registration', function (e) {
  const { params } = e
  const uriNext = is.getAttributeValue(params.trigger, 'redirect')
  const Toast = Swal.mixin(defaultSwal)
  Toast.fire({
    icon: 'success',
    title: 'Gracias por confirmar, atentamente Daniel asesor virtual.',
  })
  params.trigger.innerHTML = is.getHasAttribute(params.trigger, 'text-submit') ? is.getAttributeValue(params.trigger, 'text-submit') : 'Suscribirse a notificaciones'

  is.waitInAWhile(defaultSwal.timer).then(() => {
    params.trigger.disabled = false
    if (is.checkVariable(params.data)) {
      event.destroy() // Destroy lifecycle.
      window.location.href = uriNext
    }
  })
})
Swal.handleOn('error-subscription-registration', function (e) {
  const { params } = e
  is.captureException(params.error)

  const Toast = Swal.mixin(defaultSwal)
  Toast.fire({
    icon: 'error',
    title: 'Error al enviar los datos.',
  })
  params.trigger.disabled = false
  params.trigger.innerHTML = is.getHasAttribute(params.trigger, 'text-submit') ? is.getAttributeValue(params.trigger, 'text-submit') : 'Enviar Datos'
})
